<template>
  <div>
    <vs-popup title="URL do Vídeo (YouTube)" :active.sync="videoPopup">
      <div class="vs-alert" style="background-color: rgba(var(--vs-primary),.15); color: rgb(111, 38, 224);">
        <p>
          Muitos clientes de e-mail não mostram o vídeo embutido na mensagem, portanto, 
          ao adicionar a URL de um vídeo, ficará assim:
        </p>

        <p>
          <strong>*|YOUTUBE:[$vid=123456]|*</strong>
        </p>

        <br />

        <p>
          Não remova esse código do vídeo, pois quando o assinante receber o e-mail, 
          este código será substituído e ficará assim:
        </p>

        <br />

        <img src="https://eep.io/images/yzco4xsimv0y/L5Xa1nnLieUSGWi08MI02/b239ff2fc5c882617802503ad41226ed/youtube-example.png" />
      </div>

      <vs-input
        v-model="videoUrl"
        class="w-full mt-5"
        name="videoUrl"
        placeholder="URL do vídeo"
      />

      <vs-button
        class="mt-5 float-right"
        :disabled="videoUrl === ''"
        @click="handleVideo"
      >
        Confirmar
      </vs-button>
    </vs-popup>

    <form class="form form-vertical">
      <div class="form-body">
        <div class="row">
          <!-- Title -->
          <vx-input-group class="mb-base">          
            <vs-input
              label="Título"
              v-model="campaignData.title"
              class="w-full"
              name="title"
              v-validate="'required'"
              :disabled="Boolean(campaignData.sent_at)"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('title')"
            >
              {{ errors.first('title') }}
            </span>
          </vx-input-group>

          <!-- Subject -->
          <vx-input-group class="mb-base">          
            <vs-input
              label="Assunto do Email"
              v-model="campaignData.subject_line"
              class="w-full"
              name="subject_line"
              v-validate="'required'"
              :disabled="Boolean(campaignData.sent_at)"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('subject_line')"
            >
              {{ errors.first('subject_line') }}
            </span>
          </vx-input-group>

          <!-- Preview Text -->
          <vx-input-group class="mb-base">          
            <vs-input
              label="Texto de Pré-Visualização do Email"
              v-model="campaignData.preview_text"
              class="w-full"
              name="preview_text"
              v-validate="'required'"
              :disabled="Boolean(campaignData.sent_at)"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('preview_text')"
            >
              {{ errors.first('preview_text') }}
            </span>
          </vx-input-group>

          <!-- From Name -->
          <vx-input-group class="mb-base">          
            <vs-input
              label="Nome do Remetente do Email"
              v-model="campaignData.from_name"
              class="w-full"
              name="from_name"
              v-validate="'required'"
              :disabled="Boolean(campaignData.sent_at)"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('from_name')"
            >
              {{ errors.first('from_name') }}
            </span>
          </vx-input-group>

          <!-- Reply To -->
          <vx-input-group class="mb-base">          
            <vs-input
              type="email"
              label="Email que Receberá as Respostas"
              v-model="campaignData.reply_to"
              class="w-full"
              name="email"
              v-validate="'required|email'"
              :disabled="Boolean(campaignData.sent_at)"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('email')"
            >
              {{ errors.first('email') }}
            </span>
          </vx-input-group>

          <!-- Content -->
          <vx-input-group class="mb-base">
            <vs-input 
              type="file" 
              @change="handleImages" 
              id="selectFile" 
              hidden
              accept="image/jpeg, image/png"
            />
            <button
              type="button"
              id="selectVideo"
              @click="handleVideoClick"
              style="display: none;"
            ></button>
            <label class="vs-input--label">Conteúdo da Campanha</label>         
            <quill-editor
              v-model="campaignData.content"
              :options="editorOptions"
              class="w-full"
              rows="10"
              name="content"
              id="content"
              v-validate="'required'"
              ref="quillEdit"
              :disabled="Boolean(campaignData.sent_at)"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('content')"
            >
              {{ errors.first('content') }}
            </span>
          </vx-input-group>

          <!-- Activated -->
          <vx-input-group class="mb-base" v-if="campaignData.id">
            <vs-checkbox
              v-model="campaignData.activated"
              class="custom-control-label"
              name="activated"
              :disabled="Boolean(campaignData.sent_at)"
            >
              Ativo
            </vs-checkbox>
          </vx-input-group>

          <!-- SEGMENTS -->
          <vx-input-group class="mt-3 mb-5">
            <h2 class="mb-1">Segmentos da Campanha</h2>
            <small>
              Determina quais assinantes receberão a campanha de newsletter, 
              com base nos segmentos escolhidos
            </small>

            <!-- CAMPAIGN NOT SENT -->
            <div v-if="!campaignData.sent_at" class="mt-2">
              <span
                class="text-danger text-sm"
                v-show="errors.has('segmentos')"
              >
                {{ errors.first('segmentos') }}
              </span>

              <ul>
                <li v-for="category in categories" :key="`segment-${category.id}`" class="mb-3">
                  <vs-checkbox
                    v-model="newsletterCampaignSegments"
                    :vs-value="category.id"
                    name="segmentos"
                    :id="`segmentos-${category.id}`"
                    v-validate="'required'"
                  >
                    {{category.name}}
                  </vs-checkbox>
                </li>
              </ul>
            </div>

            <!-- CAMPAIGN SENT -->
            <div v-else class="mt-2">
              <p v-if="!campaignSentSegments.length" class="mt-2">
                Nenhum segmento atrelado
              </p>

              <vs-chip
                :key="`segment-${category.id}`"
                v-for="category in campaignSentSegments"
                color="dark"
                class="mt-3 mr-3"
                style="font-size: 0.9rem;"
              >
                {{ category.name }}
              </vs-chip>
            </div>
          </vx-input-group>

          <!-- Submit -->
          <vx-input-group style="clear: both;" v-if="!campaignData.sent_at">
            <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">
              Salvar
            </vs-button>
          </vx-input-group>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'

  import { quillEditor } from 'vue-quill-editor'
  import toolbarOptions from '@/utils/defaultToolbarOptions'

  import moduleCategory from '@/store/category/moduleCategory'
  import moduleCampaign from '@/store/newsletter/campaign/moduleCampaign'
  import moduleTemplate from '@/store/newsletter/template/moduleTemplate'
  import newsletterCampaignSegmentHttp from '@/http/requests/newsletterCampaignSegment'
  import {
    encodeToBase64,
    decodeFromBase64,
    detectAndRemoveFileFromBucket,
    uploadFile
  } from '@/utils'

  export default {
    name: 'newsletter-campaign-form',
    props: {
      campaign: {
        type: Object,
        required: false,
        default: () => {
          return {
            id: null,
            mailchimp_id: '',
            subject_line: '',
            preview_text: '',
            title: '',
            from_name: '',
            reply_to: '',
            content: '',
            activated: true
          }
        }
      }
    },
    data() {
      return {
        campaignData: {},
        chosenTemplate: {},
        editorOptions: {
          theme: "snow",
          placeholder: "Conteúdo da campanha...",
          modules: {
            toolbar: {
              container: toolbarOptions,
              handlers: {
                image: function() {
                  document.getElementById('selectFile').click()
                },
                video: function() {
                  document.getElementById('selectVideo').click()
                }
              }
            }
          }
        },
        categories: [],
        newsletterCampaignSegments: [],
        campaignSentSegments: [],
        videoPopup: false,
        videoUrl: '',
        quillEditorRange: 0
      }
    },
    watch: {
      videoPopup(videoPopup) {
        if (!videoPopup) {
          this.videoUrl = ''
        }
      }
    },
    computed: {
      isFormValid() {
        return !this.errors.any()
      }
    },
    methods: {
      handleVideoClick() {
        this.quillEditorRange = this.$refs.quillEdit.quill.getSelection().index
        this.videoPopup = true
      },
      handleVideo () {
        this.videoPopup = false
        let videoUrl = this.videoUrl.split('/')
        videoUrl = videoUrl[videoUrl.length - 1]

        if (videoUrl.includes('v=')) {
          videoUrl = videoUrl.split('v=')[1]
        }

        this.$refs.quillEdit.quill.insertText(
          this.quillEditorRange,
          `*|YOUTUBE:[$vid=${videoUrl}]|*`,
          'user'
        )
      },
      /**
       * Detect if image was removed to delete it from Amazon S3
       */
      onTextChange(delta, oldDelta) {
        detectAndRemoveFileFromBucket(oldDelta, this.$refs.quillEdit)
      },
      handleImages(e) {
        uploadFile(e).then(uploadedImage => {
          const range = this.$refs.quillEdit.quill.getSelection()
          this.$refs.quillEdit.quill.insertEmbed(range.index , 'image', uploadedImage.fileUrl)
        })
      },
      setCampaignData(data) {
        this.campaignData = this.$_.cloneDeep(data)
        this.campaignData.content = decodeFromBase64(this.campaignData.content);
      },
      submitData() {
        const campaignData = this.$_.cloneDeep(this.campaignData);
        campaignData.content = encodeToBase64(campaignData.content);
        
        this.$validator.validateAll().then(result => {
          if (result) {
            campaignData.newsletter_campaign_segments = `[${this.newsletterCampaignSegments.join(",")}]`

            if (campaignData.id !== null && campaignData.id >= 0) {
              delete campaignData.mailchimp_id
              // Edit
              this.$store.dispatch("newsletterCampaign/update", campaignData).then(() => {
                // Redirect to list page
                this.$router.push("/newsletter/campaigns/list")
              }).catch(err => {
                console.error(err)
              })
            } else {
              // New
              delete campaignData.id
              delete campaignData.mailchimp_id
              delete campaignData.activated
              this.$store.dispatch("newsletterCampaign/add", campaignData).then(() => {
                // Redirect to list page
                this.$router.push("/newsletter/campaigns/list")
              }).catch(err => {
                console.error(err)
              })
            }
          }
        })
      }
    },
    async created() {
      this.setCampaignData(this.campaign);

      if (!moduleCampaign.isRegistered) {
        this.$store.registerModule('newsletterCampaign', moduleCampaign)
        moduleCampaign.isRegistered = true
      }

      const campaignId = this.$route.params.id;

      // The following logic will only work on "update" page
      if (campaignId) {
        await this.$store.dispatch("newsletterCampaign/infos", campaignId)
        this.setCampaignData(this.$store.state.newsletterCampaign.campaignInfos);

        // Get attached segments on this campaign
        let segments = await newsletterCampaignSegmentHttp.campaignSegments(campaignId);
        segments = segments.data.data.campaignSegments.categories
        this.newsletterCampaignSegments = segments.map(segment => segment.id);

        if (this.campaignData.sent_at) {
          this.campaignSentSegments = segments.map(segment => segment);
        }
      }

      const routeName = this.$route.name;

      if (routeName === "newsletter-campaigns-create") {
        const templateId = this.$route.query.template;

        // If the user previously chosen a template to create the campaign, replace the starter campaign content
        // with the template content
        if (templateId) {
          if (!moduleTemplate.isRegistered) {
            this.$store.registerModule('newsletterTemplate', moduleTemplate)
            moduleTemplate.isRegistered = true
          }

          await this.$store.dispatch("newsletterTemplate/infos", templateId)
          this.chosenTemplate = this.$store.state.newsletterTemplate.templateInfos;
          this.campaignData.content = decodeFromBase64(this.chosenTemplate.content);
        }
      }

      if (!moduleCategory.isRegistered) {
        this.$store.registerModule('category', moduleCategory)
        moduleCategory.isRegistered = true
      }

      const result = await this.$store.dispatch("category/fetch", {
        activated: true,
        order_by: 'name_asc'
      })

      this.categories = result.data.data.categories.items;
    },
    mounted() {
      this.$refs.quillEdit.quill.on("text-change", this.onTextChange);
    },
    components: {
      quillEditor,
      VuePerfectScrollbar
    }
  }
</script>